import type React from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { openConfirmPopup } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import type { TPackageImportFormValues } from './defaultFormValues';
import { PackageImportForm } from './PackageImportForm';

interface PackageImportFeatureProps {
  onPackageImport: VoidFunction;
}

function PackageImportFeature({ onPackageImport }: PackageImportFeatureProps): React.JSX.Element {
  const { t } = useTranslation();

  const onSubmit = (values: TPackageImportFormValues) => {
    const onConfirm = async () => {
      const formValues = values;
      const sourceType = formValues.content.source.source_type.value;
      if (sourceType === 'file') {
        // @ts-expect-error luna client types expected
        const { data } = await apiContainer.lunaClient.objects.create(formValues.content.source.file.reference[0]);
        formValues.content.source.zip = { reference: data.external_url };

        delete formValues.content.source.file;
        formValues.content.source.source_type = { value: 'zip' };
      }
      // @ts-expect-error luna client types expected
      await apiContainer.lunaClient.tasks.estimator(formValues);

      toast.info(t('features:packageImport.package_import_form.confirm_popup.on_confirm_toast'));
      onPackageImport();
    };

    openConfirmPopup({
      title: t('features:packageImport.package_import_form.confirm_popup.title') as unknown as string,
      message: t('features:packageImport.package_import_form.confirm_popup.message'),
      type: 'info',
      onConfirm,
    });
  };
  return (<PackageImportForm onSubmit={onSubmit} />);
}

export { PackageImportFeature };
